/* eslint-disable react/prop-types */

import { Divider } from "primereact/divider";

const Attachments = (props: any) => {
  const bytesToSize = (bytes: any) => {
    var sizes = ["B", "KB", "MB", "GB", "TB", "P"];
    for (var i = 0; i < sizes.length; i++) {
      if (bytes <= 1024) {
        return bytes + " " + sizes[i];
      } else {
        bytes = parseFloat((bytes / 1024) as unknown as string).toFixed(2);
      }
    }
    return bytes + " P";
  };

  return (
    <>
      <h2 className="text-lg font-medium">Attachments</h2>
      <ul className="mt-4">
        <>
          {props[0]?.map((item: any, index: number) => (
            <>
              <li key={index} className="text-sm w-full flex flex-row">
                <span className="w-1/4">{item.placeholder} :</span>
                <span className="w-3/4 text-ellipsis overflow-hidden">
                  {item.attachmentId} - {bytesToSize(item.size)}
                </span>
              </li>
              <Divider />
            </>
          ))}
        </>
      </ul>
    </>
  );
};

export default Attachments;
